function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.625 12.7523V14.6875C14.625 15.1362 14.2612 15.5 13.8125 15.5H8.125V18.1034C8.125 18.3589 7.96829 18.5898 7.7251 18.6946C7.48231 18.7977 7.19784 18.7549 7.0003 18.5843L0.22298 12.7309C0.0813515 12.6079 0 12.4329 0 12.25C0 12.0671 0.0813515 11.8922 0.22298 11.7692L7.0003 5.91624C7.19789 5.74526 7.48231 5.70199 7.7251 5.80594C7.96829 5.90989 8.125 6.14155 8.125 6.39627V9.00003L14.1759 12.0255C14.4512 12.1631 14.625 12.4444 14.625 12.7523ZM25.777 6.89418L18.9997 1.04088C18.8021 0.870307 18.5177 0.827448 18.2749 0.930585C18.0317 1.03535 17.875 1.2662 17.875 1.52173V4.12503H12.1875C11.7388 4.12503 11.375 4.48883 11.375 4.93753V6.87275C11.375 7.18064 11.5488 7.46192 11.8241 7.59959L17.875 10.625V13.2291C17.875 13.4831 18.0317 13.7148 18.2749 13.8195C18.5177 13.9226 18.8022 13.8798 18.9997 13.7084L25.777 7.85583C25.9186 7.73284 26 7.55789 26 7.37498C26 7.19207 25.9186 7.01718 25.777 6.89418Z",
  fill: "#EFEFEF"
});

var SvgTradeFreqIcon = function SvgTradeFreqIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTradeFreqIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trade-freq-icon.a8a9ebe4.svg";
export { ForwardRef as ReactComponent };